import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, OnDestroy } from '@angular/core';

import { TournamentsService } from '../tournaments/services/tournaments.service';

import { translationHelper } from '~/helpers/translation.helper';

declare let $;
declare let ChangeLanguage: any;
declare let langId;

@Component({
    selector: 'comp_languagemodal',
    templateUrl: './language_modal.html',
})
export class LanguageModal implements OnInit, OnDestroy {
    @Output('selectedLanguage_LangCode') public selectedLanguage_LangCode = new EventEmitter();

    public selectedLanguage = 2;
    public init: boolean;
    private languageChannel: BroadcastChannel;

    constructor(public tournamentsService: TournamentsService, private _translationHelper: translationHelper) {
        this.selectedLanguage = langId;
        // Initialize broadcast channel for language changes
        this.languageChannel = new BroadcastChannel('language_change_channel');
    }

    public ngOnInit() {
        if (this.init) {
            return;
        }
        this.init = true;
    }

    public ngOnDestroy() {
        // Close the channel when component is destroyed
        if (this.languageChannel) {
            this.languageChannel.close();
        }
    }

    public changeLanguage(newlangId, langCode) {
        this.tournamentsService.clearSlip();
        this.tournamentsService.removeGroup(langId);

        this.tournamentsService.addgroup(newlangId);

        this.selectedLanguage = newlangId;
        ChangeLanguage(langCode, newlangId);
        this._translationHelper.changeLang(langCode);

        this.selectedLanguage_LangCode.next(langCode);

        // Broadcast language change to all tabs
        this.languageChannel.postMessage({
            type: 'language_changed',
            language: langCode,
            languageId: newlangId,
        });

        setTimeout(function() {
            $('#Language_Modal').modal('hide');
        }, 1000);

        this.tournamentsService.ChangeLanguage();
    }
}
